// extracted by mini-css-extract-plugin
export default {"subtitulo":"ServiciosCrear_subtitulo__ezHsg"};